export function DataTable({ columns, data, renderMobileCard, emptyMessage = 'No data' }) {
  if (!data?.length) {
    return <p className="text-center text-sm text-muted py-8">{emptyMessage}</p>;
  }

  return (
    <>
      <div className="hidden md:block overflow-x-auto rounded-xl border border-border">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-surface">
              {columns.map((col) => (
                <th key={col.key} className="px-4 py-3 text-left font-medium text-muted">
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={row.id ?? i} className="border-b border-border last:border-0 hover:bg-surface/50">
                {columns.map((col) => (
                  <td key={col.key} className="px-4 py-3 text-text">
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="md:hidden space-y-3">
        {data.map((row, i) => (
          <div key={row.id ?? i}>{renderMobileCard(row)}</div>
        ))}
      </div>
    </>
  );
}
